import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/loader';

const ProtectedRoute = ({ children }) => {
    const isAuthenticated = useIsAuthenticated();
    const { inProgress, accounts } = useMsal();
    const navigate = useNavigate();

    const msalReady = inProgress === InteractionStatus.None;
    const hasAccount = accounts && accounts.length > 0;

    useEffect(() => {
        if (msalReady && !isAuthenticated && !hasAccount) {
            navigate("/login", { replace: true });
        }
    }, [msalReady, isAuthenticated, hasAccount, navigate]);

    if (!msalReady || (!isAuthenticated && !hasAccount)) {
        return <Loader />;
    }

    return children;
};


export default ProtectedRoute;